<template>
  <v-main class="app-layout">
    <v-fade-transition mode="out-in">
      <router-view ref="view"> </router-view>
    </v-fade-transition>
  </v-main>
</template>

<script>
export default {
  data: () => ({}),
};
</script>
